import { useMemo } from "react";
import { mergeStyleSets } from "@fluentui/react/lib/Styling";
import { useTheme } from "@fluentui/react/lib/Theme";

const classNames = {
  root: `NavigationRoot`,
  items: `NavigationItems`,
  item: `NavigationItem`,
  itemText: `NavigationItemText`,
  itemCheck: `NavigationItemCheck`,
  navIcon: `NavigationIcon`
};

export function useNavigationStyles() {
  const { semanticColors } = useTheme();
  return useMemo(
    () => mergeStyleSets({
      root: [
        classNames.root,
        {
          borderRight: `1px solid ${semanticColors.menuDivider}`,
          width: `25%`,
          height: `100%`,
          overflowY: `scroll`,
          flexShrink: `0 !important`
        }
      ],
      items: [classNames.items, {}],
      item: [
        classNames.item,
        {
          overflow: `hidden`
        }
      ],
      itemText: [
        classNames.itemText,
        {
          overflow: `hidden`
        }
      ],
      itemCheck: [classNames.itemCheck, {}],
      navIcon: [
        classNames.navIcon,
        {
          "& i": {
            color: semanticColors.buttonTextDisabled
          }
        }
      ]
    }),
    [semanticColors]
  );
}
